import { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuthContext } from '../../../auth/AuthProvider';
import { LogoutReason, idleTimeoutMin } from '../../../constants/LOGOUT';


export default function LogoutIdleTimer() {
    const timeoutMs = idleTimeoutMin * 60 * 1000;
    const [, setRemaining] = useState(timeoutMs);
    const authContext = useAuthContext();

    const handleOnIdle = () => {
        if (authContext.isAuthenticated) {
            authContext.logoutWithRedirect(LogoutReason.Timeout);
        };
    };

    const { getRemainingTime } = useIdleTimer({
        timeout: timeoutMs,
        onIdle: handleOnIdle
    });

    useEffect(() => {
        setRemaining(getRemainingTime());
        setInterval(() => {
            setRemaining(getRemainingTime());
        }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;

};
